"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActorFunctionFactoryTermGreaterThan = void 0;
const bus_function_factory_1 = require("@comunica/bus-function-factory");
const utils_expression_evaluator_1 = require("@comunica/utils-expression-evaluator");
const TermFunctionGreaterThan_1 = require("./TermFunctionGreaterThan");
/**
 * A comunica TermFunctionGreaterThan Function Factory Actor.
 */
class ActorFunctionFactoryTermGreaterThan extends bus_function_factory_1.ActorFunctionFactoryDedicated {
    constructor(args) {
        super({
            ...args,
            functionNames: [utils_expression_evaluator_1.SparqlOperator.GT],
            termFunction: true,
        });
        this.mediatorFunctionFactory = args.mediatorFunctionFactory;
    }
    async run(args) {
        const lessThanFunction = await this.mediatorFunctionFactory.mediate({
            functionName: utils_expression_evaluator_1.SparqlOperator.LT,
            requireTermExpression: true,
            context: args.context,
            arguments: args.arguments,
        });
        return new TermFunctionGreaterThan_1.TermFunctionGreaterThan(lessThanFunction);
    }
}
exports.ActorFunctionFactoryTermGreaterThan = ActorFunctionFactoryTermGreaterThan;
//# sourceMappingURL=ActorFunctionFactoryTermGreaterThan.js.map